// extracted by mini-css-extract-plugin
module.exports = {"features_wrapper":"pricing-features_features_wrapper__kJ6v1","title":"pricing-features_title__vPJkx"};